import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import DatePickers from './DatePicker'
import Email from './Email'
import Phone from './Phone'
import Address from './Address'
import LongText from './LongText'
import MultiChoice from './MultiChoice';
import SingleChoice from './SingleChoice'

const HealthAndWellnessIntakeForm = () => {


    const exerciseData = [
        {
            id: 1,
            label: 'هرگز',
            checked: false
        },
        {
            id: 2,
            label: 'به ندرت (۱ تا ۲ بار در ماه)',
            checked: false
        },
        {
            id: 3,
            label: 'گاهی اوقات (۱ تا ۲ بار در هفته)',
            checked: false
        },
        {
            id: 4,
            label: 'به طور منظم (۳ تا ۴ بار در هفته)',
            checked: false
        },
        {
            id: 5,
            label: 'روزانه',
            checked: false
        },

    ]


    const dietaryData = [
        {
            id: 1,
            label: "گیاهخواری",
            checked: false
        },
        {
            id: 2,
            label: "وگان",
            checked: false
        },
        {
            id: 3,
            label: "بدون گلوتن",
            checked: false
        },
        {
            id: 4,
            label: "بدون لبنیات",
            checked: false
        },
        {
            id: 5,
            label: "کتو",
            checked: false
        },
        {
            id: 6,
            label: "پالئو",
            checked: false
        },
        {
            id: 7,
            label: "ترجیح خاصی ندارم",
            checked: false
        },
    ]




    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم دریافت اطلاعات سلامت و تندرستی'} subHeader={'لطفا این فرم را پر کنید تا به ما در درک نیازهای سلامتی و تندرستی شما کمک کند.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <DatePickers header={'تاریخ تولد'} />
                <Email header={'آدرس ایمیل'} />
                <Phone header={'شماره تلفن'} />
                <Address header={'آدرس'} />
                <LongText header={'نگرانی‌های فعلی در مورد سلامت'} />
                <LongText header={'آیا آلرژی دارید؟'} />
                <LongText header={'داروهای فعلی'} />
                <MultiChoice header={'داروهای فعلیفراوانی ورزش'} options={exerciseData} />
                <SingleChoice header={'ترجیحات غذایی'} options={dietaryData} />
            </Grid>
        </Grid>
    )
}

export default HealthAndWellnessIntakeForm
